import { render, staticRenderFns } from "./CampaignPage.vue?vue&type=template&id=dcb20746&scoped=true&"
import script from "./CampaignPage.vue?vue&type=script&lang=js&"
export * from "./CampaignPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb20746",
  null
  
)

export default component.exports